import UsersCardsContainer from "../../../components/applications/users/usersCard";

const UsersCard = () => {
  return <UsersCardsContainer />;
};

export default UsersCard;
